import { render, staticRenderFns } from "./PartnerUserBulkDelete.vue?vue&type=template&id=58dbedae&scoped=true"
import script from "./PartnerUserBulkDelete.vue?vue&type=script&lang=ts"
export * from "./PartnerUserBulkDelete.vue?vue&type=script&lang=ts"
import style0 from "./PartnerUserBulkDelete.vue?vue&type=style&index=0&id=58dbedae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dbedae",
  null
  
)

export default component.exports